import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, MessageSquare } from 'lucide-react';
import logo from '../assest/foundationlogo.jpeg'
const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 pt-20 pb-10">
      <div className="max-w-8xl mx-auto px-12 ">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Brand Column */}
          <div className="col-span-1 lg:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <div className=" p-1.5 rounded-lg">
               
                <img src={logo} alt="Logo" className="w-18 h-12 object-contain" />
              </div>
              <span className="text-xl font-bold text-white tracking-tight">SRIDHAR ORAL HEALTH CARE</span>
            </div>
            <p className="text-sm leading-relaxed mb-6">
              Serving smiles since 1995. Sridhar Dental Hospital & Foundation is a pioneer in advanced dental treatments and community outreach.
            </p>
            
            {/* SOCIAL LINKS - FIXED VERSION */}
            <div className="flex gap-4">
              <a 
                href="https://www.facebook.com/sridhardental1995/" 
                target="_blank" 
                rel="noreferrer" 
                className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center hover:bg-primary text-white transition-all"
                aria-label="Facebook"
              >
                {/* Manual SVG for Facebook so it never breaks */}
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                   <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z" />
                </svg>
              </a>
              <a href="mailto:info@sridhardental.com" className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center hover:bg-primary text-white transition-all" aria-label="Email">
                <MessageSquare size={20} />
              </a>
            </div>
          </div>

          {/* ... Rest of the footer code (Quick Links, Services, Contact) remains the same ... */}
          {/* Ensure you keep the rest of the Footer content I provided previously */}
          
          <div>
            <h4 className="text-white font-bold mb-6 flex items-center gap-2">
              Quick Links <div className="w-8 h-px bg-primary"></div>
            </h4>
            <ul className="space-y-4 text-sm">
              <li><Link to="/#home" className="hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/#services" className="hover:text-primary transition-colors">Services</Link></li>
              <li><Link to="/#camps" className="hover:text-primary transition-colors">Dental Camps</Link></li>
              <li><Link to="/#contact" className="hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
             <h4 className="text-white font-bold mb-6 flex items-center gap-2">
              Contact <div className="w-8 h-px bg-primary"></div>
            </h4>
            <div className="space-y-4 text-sm">
              <div className="flex gap-3 text-slate-300">
                <MapPin className="text-primary shrink-0" size={18} />
                <p> Vijayawada</p>
              </div>
              <div className="flex gap-3 text-slate-300">
                <Phone className="text-primary shrink-0" size={18} />
                <p>+91 94909 48081<br/>
                +91 95420 27700</p>
              </div>
              <div className="flex gap-3 text-slate-300">
                <Mail className="text-primary shrink-0" size={18} />
                <p>info@sridhardental.com</p>
              </div>
            </div>
          </div>

        </div>
        
        <div className="pt-8 border-t border-slate-900 text-center text-xs uppercase tracking-widest font-bold">
          <p>© {new Date().getFullYear()} Sridhar Dental Hospital Foundation</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;